module.exports = __webpack_public_path__ + "static/img/group-14@3x.c812b123.png";